module.exports = __webpack_public_path__ + "static/media/14.b22dae43.png";